var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7861 5.35686H9.87542V2.35686C9.87542 1.40999 9.10801 0.642578 8.16113 0.642578H4.8397C3.89283 0.642578 3.12542 1.40999 3.12542 2.35686V5.35686H2.2147C1.97765 5.35686 1.78613 5.54838 1.78613 5.78544V10.9283C1.78613 11.1653 1.97765 11.3569 2.2147 11.3569H10.7861C11.0232 11.3569 11.2147 11.1653 11.2147 10.9283V5.78544C11.2147 5.54838 11.0232 5.35686 10.7861 5.35686ZM6.87542 8.53097V9.24079C6.87542 9.29972 6.8272 9.34794 6.76828 9.34794H6.23256C6.17363 9.34794 6.12542 9.29972 6.12542 9.24079V8.53097C6.01486 8.4516 5.93235 8.33919 5.88974 8.20994C5.84714 8.08068 5.84665 7.94124 5.88834 7.81169C5.93003 7.68213 6.01175 7.56915 6.12174 7.489C6.23174 7.40885 6.36432 7.36567 6.50042 7.36567C6.63651 7.36567 6.7691 7.40885 6.87909 7.489C6.98908 7.56915 7.07081 7.68213 7.1125 7.81169C7.15419 7.94124 7.1537 8.08068 7.11109 8.20994C7.06849 8.33919 6.98597 8.4516 6.87542 8.53097ZM8.91113 5.35686H4.0897V2.35686C4.0897 1.94302 4.42586 1.60686 4.8397 1.60686H8.16113C8.57497 1.60686 8.91113 1.94302 8.91113 2.35686V5.35686Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.30606821f58b6aff4b3fd8054c844294.svg";
export { ForwardRef as ReactComponent };